<template>
  <Layout>
    <template #header>
      <Heading>{{ $t('ppm_modal__welcome_heading') }}</Heading>
      <Subheading>{{ $t('ppm_modal__add_welcome_subheading') }}</Subheading>
    </template>

    <template #image>
      <img :src="mainImg" alt="" />
    </template>

    <template #default>
      <Paragraph class="ws-paragraph">
        {{ $t('ppm_modal__add_welcome_text_p1') }}
      </Paragraph>
    </template>

    <template #vertical-footer>
      <HotPinkButton
        data-testid="add-ppm-button"
        @click="$emit('go-to-add-payment-method')"
      >
        {{ $t('ppm_modal__select_method_button') }}
      </HotPinkButton>
    </template>
  </Layout>
</template>

<script>
import Layout from '../layouts/Layout.vue'
import Heading from '../typography/Heading.vue'
import Subheading from '../typography/Subheading.vue'
import Paragraph from '../typography/Paragraph.vue'
import HotPinkButton from '../buttons/HotPinkButton.vue'

export default {
  components: {
    Layout,
    Heading,
    Subheading,
    Paragraph,
    HotPinkButton,
  },
  data() {
    return {
      mainImg: require('../assets/welcome.png'),
    }
  },
}
</script>

<style lang="postcss" scoped>
.ws-paragraph {
  /* Desktop */
  @apply lg:tw-max-w-[600px] lg:tw-text-center;
}
</style>
